import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

import { SanitizeVarForRuby } from '../../../lib/helpers';

export default {
  sanitizeTileData: rawTiles => {
    const result = { ...rawTiles };
    result.user_submitted.tiles = result.user_submitted.tiles || [];
    rawTiles.ignored.tiles.forEach(tile => {
      result.user_submitted.tiles.push({ ...tile, ignored: true });
    });
    result.user_submitted.count += rawTiles.ignored.count;
    return result;
  },
  unhandledClick: e =>
    e.target.innerText === 'Copy' ||
    e.target.innerText === 'Delete' ||
    e.target.innerText === 'Post' ||
    (e.target.classList.contains('pill') &&
      e.target.classList.contains('more')),
  purgeRepeatedTiles: (tileIDs, existingTiles, newTiles) =>
    existingTiles.concat(
      newTiles.filter(newTile => tileIDs.indexOf(newTile.id) === -1),
    ),
  getFilterParams: statusFilter =>
    Object.keys(statusFilter)
      .reduce(
        (result, status) =>
          statusFilter[status]
            ? `${result}${SanitizeVarForRuby(status)}%3D${
                statusFilter[status].value
              }%26`
            : result,
        '',
      )
      .slice(0, -3),
  sanitizeAudienceResponse: camp => ({
    label: camp.name,
    className: 'audience-option',
    value: camp.id,
    color: camp.color,
    population: camp.population_segments?.map(p => ({
      value: p.id,
      label: p.name,
    })),
  }),
  sanitizeRibbonTagResponse: tag => ({
    label: tag.name,
    className: 'ribbon-tag-option',
    value: tag.id,
    color: tag.color,
  }),
  swalModal: args => React.createElement(SweetAlert, args, args.text), // eslint-disable-line
};
